import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4422762f"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "privacy-confirmation-buttons" }
const _hoisted_6 = { class: "pc-buttons" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "is-hidden-mobile" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseHeading = _resolveComponent("BaseHeading")!
  const _component_BaseParagraph = _resolveComponent("BaseParagraph")!
  const _component_BaseListItem = _resolveComponent("BaseListItem")!
  const _component_BaseList = _resolveComponent("BaseList")!
  const _component_BaseLayoutColumn = _resolveComponent("BaseLayoutColumn")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_ButtonIcon = _resolveComponent("ButtonIcon")!
  const _component_BasePanel = _resolveComponent("BasePanel")!

  return (!_ctx.isKn && !_ctx.isPolicySelected)
    ? (_openBlock(), _createBlock(_component_BasePanel, {
        key: 0,
        class: _normalizeClass(["privacy-confirmation", { 'show-detail': _ctx.showDetail }]),
        "data-cy": "privacy-confirmation"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_BaseHeading, {
            level: "3",
            "visual-level": "4"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('privacyNotification.title')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_BaseParagraph, {
            "font-size": "small",
            class: "privacy-confirmation-msg"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", {
                innerHTML: _ctx.$t('privacyNotification.messageCore')
              }, null, 8, _hoisted_1)
            ]),
            _: 1
          }),
          (_ctx.showDetail)
            ? (_openBlock(), _createBlock(_component_BaseLayoutColumn, {
                key: 0,
                class: "details",
                gap: "24"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_BaseLayoutColumn, {
                    tag: "section",
                    gap: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_BaseHeading, { level: "4" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('privacyNotification.details.head1')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_BaseParagraph, { "font-size": "small" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_BaseList, null, {
                            default: _withCtx(() => [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (item, i) => {
                                return _createVNode(_component_BaseListItem, { key: i }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", {
                                      innerHTML: _ctx.$t(`privacyNotification.details.list1.${i+1}`)
                                    }, null, 8, _hoisted_2)
                                  ]),
                                  _: 2
                                }, 1024)
                              }), 64))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_BaseLayoutColumn, {
                    tag: "section",
                    gap: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_BaseHeading, { level: "4" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('privacyNotification.details.head2')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_BaseParagraph, { "font-size": "small" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_BaseList, null, {
                            default: _withCtx(() => [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(1, (item, i) => {
                                return _createVNode(_component_BaseListItem, { key: i }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", {
                                      innerHTML: _ctx.$t(`privacyNotification.details.list2.${i+1}`)
                                    }, null, 8, _hoisted_3)
                                  ]),
                                  _: 2
                                }, 1024)
                              }), 64))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_BaseLayoutColumn, {
                    tag: "section",
                    gap: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_BaseParagraph, { "font-size": "small" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", {
                            innerHTML: _ctx.$t('privacyNotification.details.note')
                          }, null, 8, _hoisted_4)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_BaseParagraph, { "font-size": "small" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('privacyNotification.selection.label')), 1)
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_AppButton, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showDetail = !_ctx.showDetail)),
                type: "reset",
                styled: "is-none",
                class: "has-text-link",
                "data-cy": "show-detail-button"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(`privacyNotification.selection.${_ctx.showDetail ? 'closeDetail' : 'showDetail'}`
        )), 1)
                ]),
                _: 1
              }),
              _hoisted_7,
              _createVNode(_component_ButtonIcon, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.accept('core'))),
                styled: "is-accent",
                type: "submit",
                "aria-label": _ctx.$t('privacyNotification.selection.core'),
                text: _ctx.$t('privacyNotification.selection.core'),
                "data-cy": "accept-core-button"
              }, null, 8, ["aria-label", "text"]),
              _createVNode(_component_ButtonIcon, {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.accept('all'))),
                styled: "is-accent",
                type: "submit",
                "aria-label": _ctx.$t('privacyNotification.selection.all'),
                text: _ctx.$t('privacyNotification.selection.all'),
                "data-cy": "accept-all-button"
              }, null, 8, ["aria-label", "text"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["class"]))
    : _createCommentVNode("", true)
}